export enum Protection {
  None = "none",
  Light = "light",
  Medium = "medium",
  Strict = "strict",
  Custom = "custom"
}
